var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.countdown != 0)?_c('span',[_vm._v(_vm._s(_vm._f("timeFactory")(_vm._f("formateTime")(_vm.remoteTime,_vm.countdown))))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }